(function () {
  // licht/donker thema, keuze wordt onthouden per bezoeker
  var root = document.documentElement;
  var saved = null;
  try { saved = localStorage.getItem('vk-theme'); } catch (e) {}
  function apply(mode) {
    root.setAttribute('data-theme', mode);
    document.querySelectorAll('[data-theme-toggle]').forEach(function (i) { i.checked = mode === 'dark'; });
    try { localStorage.setItem('vk-theme', mode); } catch (e) {}
  }
  apply(saved === 'dark' ? 'dark' : 'light');
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-theme-toggle]');
    if (t) apply(t.checked ? 'dark' : 'light');
  });

  // aantal-knoppen op de productpagina
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    e.preventDefault();
    var input = b.parentNode.querySelector('input');
    var v = parseInt(input.value || '1', 10);
    v = b.dataset.qty === 'up' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });

  // tabbladen op de productpagina
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (!tab) return;
    e.preventDefault();
    var wrap = tab.closest('.tabs');
    wrap.querySelectorAll('[data-tab]').forEach(function (a) { a.classList.toggle('on', a === tab); });
    wrap.querySelectorAll('[data-panel]').forEach(function (p) {
      p.style.display = p.dataset.panel === tab.dataset.tab ? '' : 'none';
    });
  });

  // galerij
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-media]');
    if (!th) return;
    var g = th.closest('.gallery');
    var main = g.querySelector('[data-media-main]');
    if (main && th.dataset.media) main.src = th.dataset.media;
    g.querySelectorAll('[data-media]').forEach(function (x) { x.classList.toggle('on', x === th); });
  });
})();
